import { supabase } from './supabase';

/**
 * Funciones para manejar el CV guardado del usuario
 * Permite guardar y pre-cargar automáticamente el CV del usuario
 */

export interface UserSavedCV {
    id: string;
    user_id: string;
    cv_text: string;
    cv_filename: string | null;
    uploaded_at: string;
    updated_at: string;
}

/**
 * Guarda o actualiza el CV del usuario
 */
export async function saveUserCV(
    userId: string,
    cvText: string,
    filename?: string
): Promise<{ success: boolean; error?: string }> {
    try {
        // Intentar actualizar primero (upsert)
        const { error } = await supabase
            .from('user_saved_cv')
            .upsert(
                {
                    user_id: userId,
                    cv_text: cvText,
                    cv_filename: filename || null,
                    updated_at: new Date().toISOString(),
                },
                {
                    onConflict: 'user_id',
                }
            );

        if (error) throw error;

        console.log('✅ CV del usuario guardado exitosamente');
        return { success: true };
    } catch (error) {
        console.error('Error guardando CV del usuario:', error);
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Error desconocido',
        };
    }
}

/**
 * Obtiene el CV guardado del usuario
 */
export async function getUserSavedCV(
    userId: string
): Promise<{ success: boolean; data?: UserSavedCV; error?: string }> {
    try {
        const { data, error } = await supabase
            .from('user_saved_cv')
            .select('*')
            .eq('user_id', userId)
            .single();

        if (error) {
            // Si no existe, no es un error crítico
            if (error.code === 'PGRST116') {
                return { success: true, data: undefined };
            }
            throw error;
        }

        console.log('✅ CV del usuario cargado');
        return { success: true, data };
    } catch (error) {
        console.error('Error obteniendo CV del usuario:', error);
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Error desconocido',
        };
    }
}

/**
 * Elimina el CV guardado del usuario
 */
export async function deleteUserSavedCV(
    userId: string
): Promise<{ success: boolean; error?: string }> {
    try {
        const { error } = await supabase
            .from('user_saved_cv')
            .delete()
            .eq('user_id', userId);

        if (error) throw error;

        console.log('✅ CV del usuario eliminado');
        return { success: true };
    } catch (error) {
        console.error('Error eliminando CV del usuario:', error);
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Error desconocido',
        };
    }
}
